import { defineMessages } from "react-intl";

export const SHIPMENT_PROBLEMS_LABELS = defineMessages({
  discrepancyTooltip: {
    id: "inbounds.shipmentProblem.tooltip.discrepancy",
    defaultMessage: "This is a discrepancy between expected and actual quantities",
  },
  palletDiscrepancyTitle: {
    id: "inbounds.shipmentProblem.palletDiscrepancy.title",
    defaultMessage: "Pallet Discrepancy",
  },
  palletDiscrepancyDescription: {
    id: "inbounds.shipmentProblem.palletDiscrepancy.description",
    defaultMessage: "Operations pallet count doesn't match the pallet count on the BOL",
  },
  missingTooltip: {
    id: "inbounds.shipmentProblem.tooltip.missing",
    defaultMessage: "Flexport confirmed that we never received these goods",
  },
  lostTooltip: {
    id: "inbounds.shipmentProblem.tooltip.lost",
    defaultMessage:
      "Flexport misplaced some of your received goods, we are investigating this in an attempt to recover them.",
  },
});
